// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_2-U6n","ico":"_3TeRA","isHideMobile":"_3fQbU"};